import OrganizationSpecialSalaryPage from './OrganizationSpecialSalaryPage';

export default OrganizationSpecialSalaryPage;
